import React from "react";
import ReactDOM from "react-dom";
import "./config/api"; // Set axios baseURL for native builds (must be before App)
import App from './App';
import './index.css';

// iOS WebKit throws benign focus() errors inside position:fixed overlays.
// Production builds ignore these, but CRA's dev overlay catches them.
// This suppresses only opaque "Script error." events with no error object.
window.addEventListener("error", (e) => {
  if (e.message === "Script error." && e.error === null) {
    e.stopImmediatePropagation();
    e.preventDefault();
  }
}, true);

const rootElement = document.getElementById('root');

if (!rootElement) {
  throw new Error("Root element not found. Ensure there is a <div id='root'> in index.html.");
}

if (rootElement.hasChildNodes()) {
  ReactDOM.hydrate(<App />, rootElement);
} else {
  ReactDOM.render(<App />, rootElement);
}